import React from 'react'
import { IJobs } from './Facturacion'
import { Box, Button, Card, CardContent, Chip, CircularProgress, Typography } from '@mui/material'
import ServerPagination from '../../../components/Common/PaginatorServer'
import { formatDate, getEstadoColor, PropsJobs } from './TablaJobs'

const CardsJobs: React.FC<PropsJobs> = ({ headers, loading, jobs, paginator, handleConsumidorFinal }) => {
  if (loading) {
    return (
      <Box display="flex" justifyContent="center" alignItems="center" minHeight={200}>
        <CircularProgress />
      </Box>
    )
  }

  return (
    <Box
      sx={{
        display: 'flex',
        flexDirection: 'column',
        width: '100%',
        gap: '0.6rem',
        margin: '1rem 0',
        padding: '0 0.5rem'
      }}
    >
      {jobs?.map((j: IJobs) => (
        <Card key={j.idFacturacionJob}>
          <CardContent sx={{ display: 'flex', flexDirection: 'column', gap: '0.5rem' }}>
            {headers.map((h) => {
              return (
                j[h.key] !== undefined &&
                j[h.key] !== null &&
                h.key !== 'estado' &&
                h.key !== 'reintentos' &&
                (h.key === 'nombreLocal' ? (
                  <Typography key={h.key}>
                    <strong>{h.label}</strong>: {`${j.nombreLocal} (${j.codigoLocal})`}
                  </Typography>
                ) : (
                  <Typography key={h.key}>
                    <strong>{h.label}</strong>: {h.key.includes('fecha') ? formatDate(j[h.key]) : j[h.key]}
                  </Typography>
                ))
              )
            })}
            <Box sx={{ display: 'flex', flexDirection: 'row', gap: '0.5rem' }}>
              <Typography>
                <strong>Estado</strong>:
              </Typography>
              <Chip label={j.estado} color={getEstadoColor(j.estado)} size="small" sx={{ fontWeight: 500 }} />
            </Box>
            {j.reintentos > 0 && (
              <Typography>
                <strong>Reintentos</strong>: {j.reintentos}
              </Typography>
            )}
            {(j.estado === 'SIN_CUIT' || j.forzarConsumidorFinal) && (
              <Button
                sx={{ mt: '0.5rem' }}
                variant="outlined"
                size="small"
                onClick={() => handleConsumidorFinal(j.idFacturacionJob)}
              >
                Consumidor final
              </Button>
            )}
          </CardContent>
        </Card>
      ))}
      <ServerPagination component={'div'} label="Jobs por página" paginator={paginator} />
    </Box>
  )
}

export default CardsJobs
